import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export interface DispersedSourceSolidIconProps {
    iconColor: string;
    striped?: boolean;
}

const DispersedSourceSolidIcon = ({ iconColor, striped, sx }: SvgIconProps & DispersedSourceSolidIconProps) => {
    return (
        <SvgIcon sx={[...(Array.isArray(sx) ? sx : [sx])]}>
            <svg width="30" height="20" viewBox="-1 0 30 20" fill={'none'} xmlns="http://www.w3.org/2000/svg">
                {striped && (
                    <defs>
                        <pattern
                            id="diagonal-stripes"
                            width="8"
                            height="10"
                            patternUnits="userSpaceOnUse"
                            patternTransform="rotate(45)"
                        >
                            <rect width="4" height="10" fill={iconColor} />
                        </pattern>
                    </defs>
                )}

                <rect
                    width="24"
                    height="20"
                    stroke="black"
                    strokeWidth="1px"
                    fill={striped ? 'url(#diagonal-stripes)' : iconColor}
                />
            </svg>
        </SvgIcon>
    );
};

export default DispersedSourceSolidIcon;
